import { Injectable } from '@angular/core';

import { UserDoc, userMethods, userPullQueryBuilder, userSchema } from '../schema/user-schema';
import { AppState } from '../app-state';

import { User } from '../models';
import { RestClient } from './rest-client';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { TestbedRxdbState } from './testbed-rxdb/testbed-rxdb-state';
import { AuthenticationService } from './authentication.service';
import { TestbedRxdbGraphQlCollectionService } from './testbed-rxdb/testbed-rxdb-graphql-collection.service';
import { TableViewQueryCriteria, TableViewQueryResponse } from '../../shared/components/table-view/table-view-component-base';

// Need rest connection to deal with saving user data since password is involved
class UserRestClient extends RestClient<User> {

    constructor(http: HttpClient, appState : AppState ) {
        super(http, 'users', appState)
    }

}
@Injectable({ providedIn: 'root' })
export class UserService extends TestbedRxdbGraphQlCollectionService<User,UserDoc> {

    restClient : UserRestClient

    constructor( appState : AppState,
            authService: AuthenticationService,
            rxdbState: TestbedRxdbState,
            http: HttpClient) {
        super('user', userSchema, appState, rxdbState, authService)

        this.methods = userMethods;

        this.syncConfig = {
            push: false,
            pull: true,
            intervalMs: this.appState.settings.get('rxdb.collections.user.intervalMs',0),
            retry: true,
            bGraphQL: true,
            query: userPullQueryBuilder(),
            graphQLSubscription:
            `subscription{
                userUpdated{
                    users{
                        _id
                    }
                }
            }`
        }

        this.restClient = new UserRestClient(http,appState)
    }

    create( user : User ) {
        console.log('Creating user ' + JSON.stringify(user))
        return this.restClient.http.post(this.restClient.urlPath, user, { observe: 'response' });
    }


    update( user : User ) {
        console.log('Updating user ' + JSON.stringify(user))
        return this.restClient.http.patch(this.restClient.urlPath, user, { observe: 'response' });
    }

    deleteUserById( userId : string ) : Observable<HttpResponse<any>> {
        console.log('Deleting user.  ID="' + userId + '"')
        if ( userId === null ) {
           return throwError('No ID set for delete user action.')
        }
        return this.restClient.http.delete(this.restClient.urlPath + '/' + userId, { observe: 'response' })
    }

    async findUsers( queryCriteria : TableViewQueryCriteria  = {}) {
        try {
            const result : any = await this.restClient.http.get(
                `${this.restClient.urlPath}/find`,
                { params: {criteria: JSON.stringify(queryCriteria)} }).toPromise()
            const resp : TableViewQueryResponse<User> = result.data
            return resp
        } catch (error) {
            console.error('findUsers() error: ' + error?.message )
            throw error
        }
    }

}